/*
 * Copyright (c) 2020. Jellybean B.V. Apeldoorn
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

import {Component, Injectable, Input, OnDestroy} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {Subject, Subscription} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SihwConfirmService {
  constructor(private bsModalService: BsModalService) {
  }

  /**
   * Open een confirmprompt
   * @param titel
   * @param vraag
   * @param jabtnTekst
   * @param neebtnTekst
   */
  public confirm(titel: string, vraag: string, jabtnTekst: string = "Ja", neebtnTekst: string = "Nee"): Promise<boolean> {
    return this.doeDlg(titel, vraag, true, jabtnTekst, neebtnTekst);
  }

  /**
   * Open een ok-prompt
   * @param titel
   * @param melding
   * @param btnTekst
   */
  public ok(titel: string, melding: string, btnTekst: string = "Ok"): Promise<boolean> {
    return this.doeDlg(titel, melding, false, btnTekst);
  }


  /**
   * Open de dialoog voor prompt of confirm. Confirm geeft ja/nee. Prompt alleen ok.
   * @param titel
   * @param melding
   * @param confirm
   * @param linkertekst Tekst op linker (of enige) button
   * @param rechtertekst Tekst op rechter (of enige) button
   */
  private async doeDlg(titel: string, melding: string, confirm: boolean, linkertekst?: string, rechtertekst?: string): Promise<boolean> {
    let dlg = this.bsModalService.show(SihwConfirmDlg, {
      initialState: {
        confirm: confirm,
        titel: titel,
        vraag: melding,
        linkertekst: linkertekst || (confirm ? "Ja" : "Ok"),
        rechtertekst: rechtertekst || "Nee"
      },
      class: 'sihwconfirm',
      backdrop: "static", //niet wegklikbaar
      keyboard: false //niet escapebaar
    });
    let subs: Subscription;
    let res = await new Promise<boolean>((resolve) => {
      // @ts-ignore
      //ook bij een destroy zal de dialoog dit aanroepen
      subs = dlg.content.resultaat.subscribe(resolve);
    });
    // @ts-ignore
    if (subs) {
      subs.unsubscribe();
    }
    return res;
  }
}


@Component({
  standalone: true,
  templateUrl: './sihwconfirmdlg.html',
  styles: [`
    .modal-footer.center {
        justify-content: center;
    }
  `]
})
export class SihwConfirmDlg implements OnDestroy{
  @Input() confirm: boolean = false;
  @Input() titel: string = "";
  @Input() vraag: string  = "";
  @Input() linkertekst: string = "Ja";
  @Input() rechtertekst: string = "Nee";
  resultaat: Subject<boolean> = new Subject<boolean>();

  private eventgestuurd: boolean = false;
  constructor(public dlg: BsModalRef) {
  }

  sluit(res: boolean) {
    //eerst het resultaat, dan hiden, ivm onhide
    if (! this.eventgestuurd) {
      this.resultaat.next(res);
      this.eventgestuurd = true;
    }
    this.dlg.hide();
  }

  /**
   * Bij destroy ook een next sturen, als dat nog niet gebeurd is
   */
  ngOnDestroy() {
    if (! this.eventgestuurd) {
      this.resultaat.next(false); //cancel = false
      this.eventgestuurd = true;
    }
  }
}
